import request from '@/utils/request'
let resquest = process.env.VUE_APP_BASE_API

export default {
  /* ---------------------------------长篇小说相关接口---------------------------- */
  //小说短剧列表
  scriptList(params) {
    return request({
      url: `${resquest}/novel/app/script/find/script`,
      method: 'get',
      params: params
    })
  },
  //小说短剧列表分页
  scriptListV2(params) {
    return request({
      url: `${resquest}/novel/app/script/find/script/v2`,
      method: 'get',
      params: params
    })
  },
  //小说短剧详情
  scriptInfo(id) {
    return request({
      url: `${resquest}//novel/app/script/details?scriptId=${id}`,
      method: 'get',
    })
  },
  //批量删除
  delAllScript(data) {
    return request({
      url: `${resquest}/novel/app/script/delete/script`,
      headers: {
        "Content-Type": 'multipart/form-data;charset=utf-8'
      },
      method: 'post',
      data: data
    })
  },
  //下载小说
  downloadText(params) {
    return request({
      url: `${resquest}/novel/app/novel/file`,
      headers: {
        "Content-Type": 'multipart/form-data;charset=utf-8'
      },
      method: 'get',
      params: params
    })
  },
  //获取章节下的正文
  getChapterContent(params) {
    return request({
      url: `${resquest}/novel/app/script/outline/outline`,
      method: 'get',
      params: params
    })
  },
  //风格标签
  labelList(params) {
    return request({
      url: `${resquest}/novel/app/script/find/label`,
      method: 'get',
      params: params
    })
  },
  //读者性别
  scriptSex(params) {
    return request({
      url: `${resquest}/novel/app/script/find/sex`,
      method: 'get',
      params: params
    })
  },
  //角色信息
  scriptProtagonist(params) {
    return request({
      url: `${resquest}/novel/app/script/find/protagonist`,
      method: 'get',
      params: params
    })
  },
  //添加小说
  djNovelAdd(data) {
    return request({
      url: `${resquest}/novel/app/script/save`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'post',
      data
    })
  },
  //更新小说
  djNovelUpdate(data) {
    return request({
      url: `${resquest}/novel/app/script/save`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'post',
      data
    })
  },
  //封面修改
  imgEdit(data) {
    return request({
      url: `${resquest}/novel/app/script/insert/img`,
      headers: {
        "Content-Type": 'multipart/form-data'
      },
      method: 'post',
      data
    })
  },
  //添加、修改短剧ai生成续写大纲
  djOutlineSave(data) {
    return request({
      url: `${resquest}/novel/app/script/outline/insert`,
      headers: {
        "Content-Type": 'application/json;charset=utf-8'
      },
      method: 'post',
      data
    })
  },
  //获取短剧大纲
  getDjOutline(params) {
    return request({
      url: `${resquest}/novel/pc/script/episodes/text/content`,
      method: 'get',
      params
    })
  },
  //保存手写大纲
  scriptOutlineWriteSave(data) {
    return request({
      url: `${resquest}/novel/app/reading/outline/script`,
      method: 'post',
      data
    })
  },
  //获取短剧大纲列表
  getDjOutlineList(params) {
    return request({
      url: `${resquest}/novel/app/script/outline/find`,
      method: 'get',
      params
    })
  },
  //获取短剧大纲列表分页
  getDjOutlineListV2(params) {
    return request({
      url: `${resquest}/novel/app/script/outline/find/v2`,
      method: 'get',
      params
    })
  },
  //获取短剧章节列表
  getDjChapterList(params) {
    return request({
      url: `${resquest}/novel/pc/script/episodes/find`,
      method: 'get',
      params
    })
  },
  //获取短剧最新章节
  getDJNewChapter(id) {
    return request({
      url: `${resquest}/novel/app/script/outline/overview/find?scriptId=${id}`,
      method: 'get',
    })
  },
  // 保存短剧章节概述 
  saveScriptChapter(data) {
    return request({
      url: `${resquest}/novel/app/script/outline/insert/overview`,
      method: 'post',
      data
    })
  },
  // 新增章节正文 
  addScriptContent(data) {
    return request({
      url: `${resquest}/novel/app/script/episodes/insert`,
      method: 'post',
      data
    })
  },
  // 修改章节正文
  saveScriptContent(data) {
    return request({
      url: `${resquest}/novel/app/script/episodes/update`,
      headers: {
        "Content-Type": 'multipart/form-data'
      },
      method: 'post',
      data
    })
  },
  // 查询章节概述
  getScriptOverview(params) {
    return request({
      url: `${resquest}/novel/pc/script/episodes/chapter/overview`,
      method: 'get',
      params
    })
  },
  //查询章节列表
  getScriptChapterList(params) {
    return request({
      url: `${resquest}/novel/app/script/episodes/find`,
      method: 'get',
      params
    })
  },
  //带id生成ai
  scriptAiCreateId(type, params, data) {
    return request({
      url: `${resquest}/novel/app/writer/script/async/${type}`,
      method: 'post',
      params,
      data
    })
  },
  //删除大纲批量
  delScriptChapter(params) {
    return request({
      url: `${resquest}/novel/app/script/outline/delete/batch`,
      method: 'post',
      params,
    })
  },
}